import React from "react"
import styled from "styled-components"
import SEO from "../components/layout/seo"
import Layout from "../components/layout/layout"

export default function PublicationPage({ pageContext: { publication: p } }) {
  const url = `https://stevewongv.github.io/research/${p.id}/`
  const paper = p.links.paper || ""
  const pdf = paper.endsWith(".pdf") ? paper : paper.includes("openaccess.thecvf.com") ? paper.replace("/html/", "/papers/").replace(".html", ".pdf") : paper.includes("arxiv.org/abs/") ? paper.replace("/abs/", "/pdf/") : null
  const meta = [
    { name: "citation_title", content: p.title },
    ...p.authors.map(author => ({ name: "citation_author", content: author })),
    { name: "citation_publication_date", content: String(p.year) },
    { name: /arXiv|TIP|IJCV|Transactions/i.test(p.venue) ? "citation_journal_title" : "citation_conference_title", content: p.venue },
    { name: "citation_abstract_html_url", content: url },
  ]
  if (pdf) meta.push({ name: "citation_pdf_url", content: pdf })
  return <Layout>
    <SEO title={p.title} description={p.technicalContext?.description || p.tldr || p.title} pathname={`/research/${p.id}/`} meta={meta} schema={{
      "@context": "https://schema.org", "@type": "ScholarlyArticle", headline: p.title, url,
      author: p.authors.map(name => ({ "@type": "Person", name })),
      datePublished: String(p.year), description: p.technicalContext?.description || p.tldr || p.title, abstract: p.abstract,
      keywords: p.technicalContext?.themes,
      sameAs: p.links.paper, isPartOf: { "@type": "CreativeWork", name: p.venue }
    }} />
    <PaperContent>
      <a href="/#publications">← All research · Tianyu (Steve) Wang</a>
      <h1>{p.title}</h1>
      <p>{p.authors.join(", ")}</p>
      <p>{p.venue} · {p.year}{p.role && ` · ${p.role}`}</p>
      {p.markerLegend && <p>{Object.entries(p.authorMarkers || {}).map(([name, markers]) => `${name}: ${markers.map(m => p.markerLegend[m]).join(", ")}`).join("; ")}</p>}
      {p.tldr && <><h2>Research summary</h2><p>{p.tldr}</p></>}
      {p.abstract && <><h2>Abstract</h2><p>{p.abstract}</p></>}
      {p.insight && <><h2>Key insight</h2><p>{p.insight}</p></>}
      {p.technicalContext && <details>
        <summary>Technical connections & research relevance</summary>
        <h2>Technical themes</h2>
        <ul>{p.technicalContext.themes.map(theme => <li key={theme}>{theme}</li>)}</ul>
        <h2>Method connections</h2>
        <p>{p.technicalContext.method}</p>
        <h2>Research relevance</h2>
        <p>{p.technicalContext.relevance}</p>
        <h2>Evaluation scope</h2>
        <p>{p.technicalContext.scope}</p>
        <h2>Primary sources</h2>
        <ul>{p.technicalContext.sources.map(source => <li key={source.url}><a href={source.url}>{source.label}</a></li>)}</ul>
      </details>}
      {p.version && <p>{p.version}</p>}
      {p.abstractSource && <p><a href={p.abstractSource}>Abstract source</a></p>}
      <h2>Paper & resources</h2>
      <ul>{Object.entries(p.links || {}).map(([label, href]) => <li key={label}><a href={href}>{label}</a></li>)}</ul>
      {p.bibtex && <><h2>BibTeX</h2><pre style={{ whiteSpace: "pre-wrap" }}>{p.bibtex}</pre></>}
      <p><a href="mailto:steve.w.vision@icloud.com">Contact Tianyu (Steve) Wang</a></p>
    </PaperContent>
  </Layout>
}

const PaperContent = styled.article`
  max-width: 860px;
  margin: 0 auto;
  padding: 112px 24px 48px;
  line-height: 1.7;
  overflow-wrap: anywhere;
  color: #24292e;
  h1 { font-size: clamp(26px, 4vw, 38px); line-height: 1.2; font-weight: 700; margin: 24px 0; }
  h2 { font-size: 22px; font-weight: 700; margin: 28px 0 12px; }
  p { margin: 16px 0; }
  a { color: #5143b8; text-decoration: underline; }
  ul { padding-left: 24px; }
  pre { padding: 16px; border-radius: 12px; background: #d5dbe3; font-size: 14px; }
`
